import { render, staticRenderFns } from "./menu-block-accordions-wrapper.vue?vue&type=template&id=c9f72332&scoped=true&"
import script from "./menu-block-accordions-wrapper.vue?vue&type=script&lang=js&"
export * from "./menu-block-accordions-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./menu-block-accordions-wrapper.vue?vue&type=style&index=0&id=c9f72332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f72332",
  null
  
)

export default component.exports